import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./firebase";

/* ============================================================
   Presença

   Marca o dia em que a pessoa abriu o app. É o que faz "usuários ativos"
   significar quem USA, e não só quem posta — a diferença importa, porque
   quem abre todo dia e posta três vezes por semana é um usuário ativo por
   qualquer definição honesta.

   Escolha deliberada: isto no lugar do Firebase Analytics. O Analytics
   daria muito mais dado de graça, mas é rastreamento de terceiros e
   entraria nas declarações de privacidade das duas lojas. Aqui uma
   escrita por pessoa por dia fica dentro do projeto, e é tudo que o
   painel precisa.

   Uma escrita por DIA, não por abertura: o localStorage guarda qual dia
   já foi marcado. Sem isso, quem abre o app oito vezes por dia gera oito
   escritas para registrar o mesmo fato.
   ============================================================ */

const CHAVE = "nhomi:visto-em";

const hoje = (): string =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
    year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());

export async function marcarPresenca(uid: string): Promise<void> {
  if (!uid) return;
  const dia = hoje();

  try {
    if (localStorage.getItem(CHAVE) === dia) return;
  } catch {
    // Armazenamento bloqueado: marca sempre. Uma escrita a mais por
    // abertura é bem melhor que não registrar a pessoa.
  }

  try {
    await setDoc(doc(db, "users", uid), {
      lastSeenDay: dia,
      lastSeenAt: serverTimestamp(),
    }, { merge: true });
    try { localStorage.setItem(CHAVE, dia); } catch { /* segue */ }
  } catch {
    // Presença é métrica, não funcionalidade. Falhar aqui não pode
    // aparecer para quem está usando o app.
  }
}
